var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import _ from 'lodash';
import SDK3387 from './3387SDK';
// import WEB3387 from './3387Web';
import APP3387 from './3387App';
import AndroidSDK4399 from './4399AndroidSDK';
import IosSDK4399 from './4399IosSDK';
import AndroidApp4399 from './4399AndroidApp';
import { getPlatform } from '../system';
var _a = getPlatform(), is3387 = _a.is3387, is4399Sy = _a.is4399Sy, is4399Dj = _a.is4399Dj, is4399IosSyPublish = _a.is4399IosSyPublish, is4399IosSyGamebox = _a.is4399IosSyGamebox, is4399GameBox = _a.is4399GameBox;
var ClientInit = /* @__PURE__ */ (function () {
    function ClientInit() {
        // 获取的客户端信息
        this.appInfo = {};
        // 获取的SDK信息
        this.sdkInfo = {};
        // 一些额外的环境判断
        this.env = {};
    }
    ClientInit.prototype.init = function () {
        var _a, _b, _c, _d, _e, _f, _g;
        return __awaiter(this, void 0, void 0, function () {
            var infos, _h, infos, infos, infos, infos, _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0:
                        if (!is3387) return [3 /*break*/, 3];
                        return [4 /*yield*/, ((_a = SDK3387.getSdk) === null || _a === void 0 ? void 0 : _a.call(SDK3387))];
                    case 1:
                        infos = [_k.sent()];
                        this.sdkInfo = _.find(infos, function (item) { return !_.isEmpty(item); }) || {};
                        _h = this;
                        return [4 /*yield*/, ((_b = APP3387.getAppInfo) === null || _b === void 0 ? void 0 : _b.call(APP3387))];
                    case 2:
                        _h.appInfo = _k.sent();
                        _k.label = 3;
                    case 3:
                        if (!is4399Sy) return [3 /*break*/, 5];
                        return [4 /*yield*/, ((_c = AndroidSDK4399.getSdk) === null || _c === void 0 ? void 0 : _c.call(AndroidSDK4399))];
                    case 4:
                        infos = [_k.sent()];
                        this.sdkInfo = _.find(infos, function (item) { return !_.isEmpty(item); }) || {};
                        _k.label = 5;
                    case 5:
                        if (!is4399Dj) return [3 /*break*/, 7];
                        return [4 /*yield*/, ((_d = AndroidSDK4399.getSdk) === null || _d === void 0 ? void 0 : _d.call(AndroidSDK4399))];
                    case 6:
                        infos = [_k.sent()];
                        this.sdkInfo = _.find(infos, function (item) { return !_.isEmpty(item); }) || {};
                        _k.label = 7;
                    case 7:
                        if (!is4399IosSyPublish) return [3 /*break*/, 9];
                        return [4 /*yield*/, ((_e = IosSDK4399.getSdk) === null || _e === void 0 ? void 0 : _e.call(IosSDK4399))];
                    case 8:
                        infos = [_k.sent()];
                        this.sdkInfo = _.find(infos, function (item) { return !_.isEmpty(item); }) || {};
                        _k.label = 9;
                    case 9:
                        if (!is4399IosSyGamebox) return [3 /*break*/, 11];
                        return [4 /*yield*/, ((_f = IosSDK4399.getSdk) === null || _f === void 0 ? void 0 : _f.call(IosSDK4399))];
                    case 10:
                        infos = [_k.sent()];
                        this.sdkInfo = _.find(infos, function (item) { return !_.isEmpty(item); }) || {};
                        _k.label = 11;
                    case 11:
                        if (!is4399GameBox) return [3 /*break*/, 13];
                        _j = this;
                        return [4 /*yield*/, ((_g = AndroidApp4399.getAppInfo) === null || _g === void 0 ? void 0 : _g.call(AndroidApp4399))];
                    case 12:
                        _j.appInfo = _k.sent();
                        _k.label = 13;
                    case 13: return [2 /*return*/];
                }
            });
        });
    };
    ClientInit.prototype.getAppInfo = function () {
        return this.appInfo;
    };
    ClientInit.prototype.getSDKInfo = function () {
        return this.sdkInfo;
    };
    ClientInit.prototype.getEnv = function () {
        return this.env;
    };
    return ClientInit;
}());
export default new ClientInit();
